
export default {
  'pricing.title': 'Exclusive Membership Options',
  'pricing.subtitle': 'Choose the perfect membership level to match your desires',
  'pricing.basic': 'Basic',
  'pricing.popular': 'Popular',
  'pricing.elite': 'Elite',
  'pricing.no_ads': 'No advertisements',
  'pricing.access_teaser': 'Access to private teaser content',
  'pricing.basic_messaging': 'Basic messaging access',
  'pricing.view_contacts': 'View escort contact details',
  'pricing.get_started': 'Get Started',
  'pricing.all_teaser': 'All Teaser benefits',
  'pricing.client_verification': 'Client verification included',
  'pricing.full_access': 'Full access to all photos & videos',
  'pricing.leave_reviews': 'Leave reviews after meetings',
  'pricing.priority_support': 'Priority support',
  'pricing.subscribe_now': 'Subscribe Now',
  'pricing.all_regular': 'All Regular benefits',
  'pricing.vip_badge': 'VIP badge on profile & messages',
  'pricing.early_access': 'Early access to new escorts',
  'pricing.vip_escorts': 'Access to VIP-only escorts',
  'pricing.discounted_rates': 'Discounted rates for premium content',
  'pricing.go_vip': 'Go VIP',
  'pricing.faq_title': 'Frequently Asked Questions',
  'pricing.faq.how_subscriptions': 'How do subscriptions work?',
  'pricing.faq.how_subscriptions_answer': 'Our subscriptions are billed monthly and provide tiered access to features and content. You can upgrade, downgrade, or cancel at any time.',
  'pricing.faq.payment_secure': 'Is my payment information secure?',
  'pricing.faq.payment_secure_answer': 'Yes, we use industry-standard encryption for all transactions. We never store your complete payment details on our servers.',
  'pricing.faq.refund': 'Can I get a refund?',
  'pricing.faq.refund_answer': 'We offer prorated refunds within the first 3 days of subscription if you\'re not satisfied with our services.',
  'pricing.faq.verification': 'What is the verification process?',
  'pricing.faq.verification_answer': 'Our verification process ensures both escorts and clients are real people. It\'s quick, secure, and protects everyone\'s privacy.',
  'pricing.choose_plan': 'Choose Your Plan',
  
  // New translations for subscription plan names and prices
  'subscription.teaser.title': 'Pink Teaser',
  'subscription.teaser.price': '4,99€/month',
  'subscription.regular.title': 'Pink Regular',
  'subscription.regular.price': '19,99€/month',
  'subscription.vip.title': 'Pink VIP',
  'subscription.vip.price': '100€/month',
  
  // Additional translations for UI elements
  'pricing.privacy_title': 'Enhanced Privacy',
  'pricing.privacy_description': 'Enhanced privacy features for your complete peace of mind.',
  'pricing.content_title': 'Exclusive Content',
  'pricing.content_description': 'Access exclusive content and premium services not available to free users.',
  'pricing.support_title': 'Priority Support',
  'pricing.support_description': 'Priority customer support for all your needs.',
  'pricing.learn_more': 'Learn More',
  'pricing.see_examples': 'See Examples',
  'pricing.contact_support': 'Contact Support',
  'pricing.detailed_comparison': 'Detailed Comparison',
  'pricing.feature': 'Feature',
  'pricing.description': 'Description',
  
  // Feature descriptions
  'pricing.no_ads_description': 'Browse without intrusive ads',
  'pricing.access_teaser_description': 'Preview escorts private content',
  'pricing.basic_messaging_description': 'Ability to send basic messages',
  'pricing.view_contacts_description': 'View escorts contact information',
  'pricing.client_verification_description': 'Verification badge for increased trust',
  'pricing.full_access_description': 'Full access to private galleries',
  'pricing.leave_reviews_description': 'Ability to leave reviews after dates',
  'pricing.priority_support_description': 'Priority assistance when you need it',
  'pricing.vip_badge_description': 'Exclusive VIP badge on your profile',
  'pricing.early_access_description': 'Early access to new profiles',
  'pricing.vip_escorts_description': 'Access to VIP-only escorts',
  'pricing.discounted_rates_description': 'Preferential rates on premium services'
};
